import { styled } from "@mui/material/styles";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

export const Scrollbar = styled(SimpleBar)``;
